import ContractorName from "./ContractorName";
import ContractorLink from "./ContractorLink";


import AddressDetail from "../../../../address/components/address/AddressDetail/AddressDetail";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ContractorDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Contractor-detail-title"
                    >
                        { label || t`Contractor` }: <ContractorName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Contractor-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Contractor-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="name-label"><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="name-value" >{ data.name || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="description-label"><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="description-value" >{ data.description || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="vatId-label"><Trans>Vat Id</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="vatId-value" >{ data.vatId || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="iban-label"><Trans>Iban</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="iban-value" >{ data.iban || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="bank-label"><Trans>Bank</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="bank-value" >{ data.bank || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="swift-label"><Trans>Swift</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="swift-value" >{ data.swift || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 12} } textAlign="left" data-testid="addressId-label">
                        <Card>
                            <CardHeader subheader="Address"/>
                            <CardContent>
                                <AddressDetail showTitle={false} 
                                                               data={ data.addressIdAddress } />
                            </CardContent>
                        </Card>
                    </Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ContractorDetail;
